export default function(fields) {
  return {
    value: fields.newEmail
  }
}
